import { FC, ReactNode } from 'react'
import { Translation } from '@/helpers'
import { ComponentState } from '@/states'
import { CubeIcon } from '@heroicons/react/16/solid'

const GridEmpty: FC = (): ReactNode => {
    const { Loading, Components, HasMore } = ComponentState()

    if (!Loading && Components.length === 0 && !HasMore) return (
        <div className='h-full px-4 py-16 place-content-center flex justify-center flex-col items-center align-middle'>
            <CubeIcon className='flex-shrink-0 w-10 h-10 text-[#EBEBEB]' />

            <h1 className='mt-2 text-xl font-bold tracking-tight text-[#EBEBEB]'>
                {Translation('no-components-title')}
            </h1>

            <p className='mt-2 text-[#CDD5DA] text-md text-[14px] md:w-[40%] xl-[35%] w-[75%] text-center'>
                {Translation('no-components-description')}
            </p>
        </div>
    )
}

export default GridEmpty
